<template>
  <div>
    <div 
        name="historic-container" 
        v-if="show" 
        style="
            width: 100%;
            margin-top: 72px;
        "
    >
        <v-row v-show="false">
          <v-col cols="12" >
            <h3>Tipo da Proposta:</h3>
            <v-form 
              ref="typeProposalData"
              v-model="isValidForm"
              lazy-validation
            >
              <v-row>
                  <v-col cols="12" sm="3">
                    <v-select
                      outlined
                      label="Tipo *"
                      :items="options"
                      :readonly="isReadonly || (editProposalId || proposalId || fixedProposalType)? true : false"
                      :disabled="isReadonly || (editProposalId || proposalId || fixedProposalType)? true : false"
                      v-model="typeProposal.type"
                      :rules="rulesRequired"
                    >
                    </v-select>
                  </v-col>
                  <!-- Start  Performance Model-->
                  <v-col
                    :cols="12"
                    sm="2"
                    v-if="typeProposal.type === 'model_performance'"
                  >
                    <v-text-field
                      outlined
                      label="Cliente *"
                      suffix="%"
                      type="Number"
                      v-model="typeProposal.client_percentage"
                      :rules="[rulesRange]"
                      :disabled="isReadonly"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    :cols="12"
                    sm="1"
                    v-if="typeProposal.type === 'model_performance'"
                  >
                    <v-text-field
                      label="Franqueadora"
                      suffix="%"
                      type="Number"
                      disabled
                      :value="typeProposal.provider_percentage"
                      :rules="[rulesRange]"
                    />
                  </v-col>
                  <v-switch
                    v-model="typeProposal.isFranchise"
                    :label="'Franquia?'"
                    inset
                    :disabled="isReadonly"
                    v-if="typeProposal.type === 'model_performance'"
                  ></v-switch>
                  <v-col
                    :cols="12"
                    sm="2"
                    v-if="typeProposal.type === 'model_performance' && typeProposal.isFranchise"
                  >
                    <v-text-field
                      outlined
                      label="Franqueado"
                      suffix="%"
                      type="Number"
                      v-model="typeProposal.franchise_percentage"
                      :rules="[rulesRange]"
                      :disabled="isReadonly"
                    />
                  </v-col>
                  <v-col
                    :cols="12"
                    sm="2"
                    v-if="typeProposal.type === 'model_performance'"
                  >
                    <v-text-field
                      outlined
                      label="Prazo do contrato *"
                      suffix="Meses"
                      type="Number"
                      v-model="typeProposal.contract_time"
                      :rules="rulesRequired"
                      :disabled="isReadonly"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- End Performance Model-->
                  <!-- Start  Pre fixed-->
            
                  <v-col :cols="12" sm="3" v-if="typeProposal.type === 'pre_fixed'">
                    <v-text-field
                      outlined
                      label="Mensalidade *"
                      prefix="R$"
                      type="Number"
                      v-model="typeProposal.monthly_payment"
                      :rules="rulesRequired"
                      :disabled="isReadonly"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col :cols="12" sm="3" v-if="typeProposal.type === 'pre_fixed'">
                    <v-text-field
                      outlined
                      label="Economia garantida *"
                      prefix="R$"
                      type="Number"
                      v-model="typeProposal.guaranteed_savings"
                      :rules="rulesRequired"
                      :disabled="isReadonly"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col :cols="12" sm="3" v-if="typeProposal.type === 'pre_fixed'">
                    <v-text-field
                      outlined
                      label="Prazo do contrato "
                      suffix="Meses"
                      type="Number"
                      v-model="typeProposal.contract_time"
                      :rules="rulesRequired"
                      :disabled="isReadonly"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- End Pre fixed-->
                  <!-- Start Value Sell-->
                  <v-col :cols="12" sm="3" v-if="typeProposal.type === 'payback_sell'">
                    <v-text-field
                      outlined
                      label="Investimento Total *"
                      prefix="R$"
                      v-model="typeProposal.total_investiment_for_type"
                      :rules="rulesRequired"
                      :disabled="isReadonly"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- End Investiment-->
                  <!-- Start Value Sell-->
                  <v-col :cols="4" sm="2" v-if="typeProposal.type === 'management'">
                    <v-text-field
                      outlined
                      label="Valor do Plano"
                      prefix="R$"
                      v-model="typeProposal.defaultPrice"
                      :rules="rulesRequired"
                      :disabled="isReadonly"
                    />
                  </v-col>
                  <v-col cols="6" v-if="typeProposal.type === 'management'">
                    <v-data-table
                      :headers="headersInsatallations"
                      :items="hydrometerSolutionsFormatted"
                      :items-per-page="12"
                      class="elevation-1"
                      style="width: 100%"
                      >
                      <template v-slot:top>
                          <v-toolbar flat class="rounded-lg">
                          <v-toolbar-title>{{ displayHydrometerMode === 'installation' ? 'Instalação' : 'Comodato' }} dos Hidrômetros</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-switch
                            v-model="displayHydrometerMode"
                            :label="`Modo: ${displayHydrometerMode === 'installation' ? 'Instalação' : 'Comodato'}`"
                            inset
                            true-value="loan"
                            false-value="installation"
                            :disabled="isReadonly"
                          ></v-switch>
                          </v-toolbar>
                      </template>
                  </v-data-table>
                  </v-col>
                  <v-col cols="6" v-if="typeProposal.type === 'management'">
                    <v-data-table
                      :headers="headersInsatallations"
                      :items="reservoirSolutionsFormatted"
                      :items-per-page="12"
                      class="elevation-1"
                      style="width: 100%"
                      >
                      <template v-slot:top>
                          <v-toolbar flat class="rounded-lg">
                          <v-toolbar-title>{{ displayReservoirMode === 'installation' ? 'Instalação' : 'Comodato' }} dos Sensores</v-toolbar-title>
                          <v-spacer></v-spacer>
                           <v-switch
                             v-model="displayReservoirMode"
                             :label="`Modo: ${displayReservoirMode === 'installation' ? 'Instalação' : 'Comodato'}`"
                             inset
                             true-value="loan"
                             false-value="installation"
                             :disabled="isReadonly"
                           ></v-switch>
                           </v-toolbar>
                       </template>
                   </v-data-table>
                   </v-col>
                </v-row>

            </v-form>
        </v-col>
        <v-col cols="12"><v-divider style="background-color: #C1E2F7"></v-divider></v-col>
      </v-row>
    <v-col cols="12">

        <!-- Start Table Solutions -->
        <!-- <v-data-table
            :headers="headersSolutions"
            :items="listSolutions"
            :items-per-page="12"
            class="elevation-1"
            style="width: 100%"
            >
            <template v-slot:top>
                <v-toolbar flat class="rounded-lg">
                <v-toolbar-title>Soluções do Checklist</v-toolbar-title>
                <v-spacer></v-spacer>
                </v-toolbar>
            </template>

  

        </v-data-table> -->
        <!-- End Table Solutions -->
        <!-- Start Table Produtos -->
        <!-- <v-data-table
            :headers="headersProduct"
            :items="listProducts"
            :items-per-page="12"
            class="elevation-1"
            style="width: 100%"
            >
            <template v-slot:top>
                <v-toolbar flat class="rounded-lg">
                    <v-toolbar-title>Produtos Extras</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>

  

        </v-data-table> -->
        <!-- End Table Produtos -->
        <!-- Start Table Produtos -->
        <!-- <v-data-table
          :headers="headersService"
          :items="listServices"
          :items-per-page="12"
          class="elevation-1"
          style="width: 100%"
        >
            <template v-slot:top>
             
                <v-toolbar flat class="rounded-lg">
                    <v-toolbar-title>Serviços</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>

  

        </v-data-table> -->
        <!-- End Table Produtos -->
    </v-col>
    <!-- Start DETALHAMENTO DO INVESTIMENTO -->
     <!-- <v-row>
       <v-col v-if="this.typeProposal.type != 'pre_fixed'" cols="6" sm="5" style="background-color: #1976D250;
          min-width: 150px;
          border-color: #1976D2;
          border-bottom: 5px solid #1976D2; 
          border-radius: 5px;">
        <span>Estimativa Payback</span>
        <h2> {{ getPayback }}</h2>
      </v-col>
      <v-col cols="6" sm="3" style="background-color: #1976D250;
          min-width: 150px;
          border-color: #1976D2;
          border-bottom: 5px solid #49A94D; 
          border-radius: 5px;">
        <span>Média Financeira Conta</span>
        <h2>{{formatCurrencyValue(getAccountReference)}}</h2>
      </v-col>
     </v-row> -->
    <v-row class="dataCliente" style="margin-bottom: 8px">
      
      <v-col
        cols="12"
        style="
          background: rgb(25, 118, 210);
          color: white;
          padding: 6px;
          border-style: solid;
          border-width: 0 0px 2px 0px;
        "
      >
        <h3 style="text-align: center">DETALHAMENTO DO INVESTIMENTO</h3>
      </v-col>

      <table>
        <tr style="font-weight: bolder">
          <th style="background: rgb(221, 235, 247)">
            <div class="column-header">
              <v-checkbox
                v-model="columnVisibility.solution"
                class="column-checkbox"
                hide-details
                dense
              ></v-checkbox>
              SERVIÇOS E SOLUÇÕES FOZ SUSTENTÁVEL
            </div>
          </th>
          <th style="background: rgb(25, 118, 210); color: white;">
            <div class="column-header">
              <v-checkbox
                v-model="columnVisibility.group"
                class="column-checkbox"
                hide-details
                dense
                dark
              ></v-checkbox>
              GRUPO
            </div>
          </th>
          <th style="background: rgb(25, 118, 210); color: white; width: 80px;">
            <div class="column-header">
              <v-checkbox
                v-model="columnVisibility.quantity"
                class="column-checkbox"
                hide-details
                dense
                dark
              ></v-checkbox>
              QTD
            </div>
          </th>
        </tr>
        <tr
          style="font-weight: bolder"
          v-for="(solution, index) in listSolutions"
          :key="index"
        >
        
          <td>
            <input type="checkbox" v-model="solution.selected" />
            {{ solution.solution }}
          </td>
          <td>{{ convertGroupNamePerSolution(solution.solutionId) }}</td>
          <td style="color: rgb(34, 194, 37); text-align: center">
            {{ solution.amount }}
          </td>
        </tr>
        <tr
          style="font-weight: bolder"
          v-for="(product, index) in listProducts"
          :key="'A' + index"
        >
          <td>
            <input type="checkbox" v-model="product.selected" />
            {{ product.productName }}
          </td>
          <td>{{ convertGroupNamePerSolution(product.product) }}</td>
          <td style="color: rgb(34, 194, 37); text-align: center">
            {{ product.amount }}
          </td>
        </tr>
        <tr
          style="font-weight: bolder"
          v-for="(service, index) in listServices"
          :key="'B' + index"
        >
          <td>
            <input type="checkbox" v-model="service.selected" />
            {{ service.serviceName }}
          </td>
          <td>{{ convertGroupNamePerSolution(service.service) }}</td>
          <td style="color: rgb(34, 194, 37); text-align: center">
            {{ service.amount }}
          </td>
        </tr>
      </table>
      <v-row style="font-size: 1.3rem" >
        <v-col cols="6">
          <div style="display: flex; align-items: center;">
            <v-checkbox
              v-model="columnVisibility.totalInvestment"
              class="column-checkbox"
              hide-details
              dense
              style="margin-right: 8px;"
            ></v-checkbox>
            <strong><h3 style="margin-left: 6px">Investimento Total</h3></strong>
          </div>
        </v-col>
        <v-col cols="6">
          <strong
            ><h3
              style="
                color: rgb(34, 194, 37);
                text-align: center;
                text-align: right;
                margin-right: 6px;
              "
            >
              {{ currencyFormat(sumValueTotal) }}
            </h3>
          </strong>
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>Observações:</h3>
        <RichTextEditor
          v-model="typeProposal.obs"
        />
      </v-col>
    </v-row>
    <!-- End DETALHAMENTO DO INVESTIMENTO -->
    </div>
    <v-overlay v-if="is_loading" absolute>
      <v-progress-circular
            indeterminate
            color="primary"
            :size="50"
        ></v-progress-circular>
    </v-overlay>
  </div>
</template>
  
<script>
import Proposal from "./Proposal.js";
export default Proposal;
</script>
  
<style scoped>
.actions-right .text-end {
  justify-content: flex-end !important;
}

.column-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.column-checkbox {
  margin: 0;
  padding: 0;
}

.v-text-field__details {
  margin-bottom: 0px !important; /* Remove the bottom margin */
}
</style>
